

import React from "react";

import gallery1 from "../assests/coconut.png.jpeg";
import gallery2 from "../assests/c2.jpeg";
import gallery3 from "../assests/ctreewater.jpeg";
import gallery4 from "../assests/ccopora.png";
import gallery5 from "../assests/c7.jpg";
import gallery6 from "../assests/ctree.jpeg";
import gallery7 from "../assests/c2.jpeg";
import gallery8 from "../assests/c3.jpg";
import gallery9 from "../assests/c5.jpeg";

const galleryImages = [
  {
    image: gallery1,
    title: "Fresh Coconut Farm",
  },
  {
    image: gallery2,
    title: "Tender Coconut Harvest",
  },
  {
    image: gallery3,
    title: "Premium Coconut Collection",
  },
  {
    image: gallery4,
    title: "Coconut Processing",
  },
  {
    image: gallery5,
    title: "Natural Coconut Plantation",
  },
  {
    image: gallery6,
    title: "Bulk Export Packing",
  },
  {
    image: gallery7,
    title: "Natural coconut Plantation",
  },
  {
    image: gallery8,
    title: "Bulk Export Packing",
  },
  {
    image: gallery9,
    title: "Fresh Coconut Farm",
  },
];

const Gallery = () => {
  return (
    <section
      id="gallery"
      className="py-16 md:py-20 lg:py-24 bg-green-50"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-8 lg:px-10">

        {/* Heading */}

        <div className="text-center mb-12 lg:mb-16">

          <p className="text-green-700 uppercase tracking-[4px] font-semibold text-sm md:text-base">
            Our Gallery
          </p>

          <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-800 leading-tight">
            Farm
            <span className="text-green-700">
              {" "} & Product Gallery
            </span>
          </h2>

          <p className="mt-5 max-w-3xl mx-auto text-gray-600 leading-8 text-base md:text-lg px-2">
            Explore our coconut farms, fresh harvests, premium products,
            processing facilities and export-quality packaging.
          </p>

          <div className="w-24 h-1 bg-green-700 rounded-full mx-auto mt-6"></div>

        </div>

        {/* Gallery Grid */}

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">

          {galleryImages.map((item, index) => (

            <div
              key={index}
              className="relative overflow-hidden rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-500 group cursor-pointer"
            >

              <img
                src={item.image}
                alt={item.title}
                className="w-full h-64 sm:h-72 lg:h-80 object-cover group-hover:scale-110 transition-transform duration-700"
              />

              {/* Overlay */}

              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-80 group-hover:opacity-100 transition duration-500"></div>

              {/* Content */}

              <div className="absolute bottom-0 left-0 right-0 p-6 translate-y-6 group-hover:translate-y-0 transition-all duration-500">

                <h3 className="text-white text-xl lg:text-2xl font-bold">

                  {item.title}

                </h3>

                <p className="text-gray-200 text-sm mt-2">

                  Premium Quality Coconut Products

                </p>

              </div>

            </div>

          ))}

        </div>

        {/* Bottom Section */}

        <div className="mt-16 lg:mt-20 bg-white rounded-3xl shadow-lg p-8 lg:p-12">

          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">

            <div>

              <h2 className="text-3xl lg:text-4xl font-bold text-green-700">
                100%
              </h2>

              <p className="mt-2 text-gray-600">
                Natural Products
              </p>

            </div>

            <div>

              <h2 className="text-3xl lg:text-4xl font-bold text-green-700">
                Farm
              </h2>

              <p className="mt-2 text-gray-600">
                Fresh Harvest
              </p>

            </div>

            <div>

              <h2 className="text-3xl lg:text-4xl font-bold text-green-700">
                Export
              </h2>

              <p className="mt-2 text-gray-600">
                Quality
              </p>

            </div>

            <div>

              <h2 className="text-3xl lg:text-4xl font-bold text-green-700">
                Bulk
              </h2>

              <p className="mt-2 text-gray-600">
                Supply
              </p>

            </div>

          </div>

        </div>

      </div>
    </section>
  );
};

export default Gallery;